import { CouponCheckApplicabilityProps } from "_interfaces/http-requests/coupon";
import { COUPON_CHECK_APPLICABILITY } from "config/endpoint";
import { HTTP } from "functions/http";

export const CouponCheckApplicability = ({
  DATA,
}: CouponCheckApplicabilityProps) => {
  return HTTP({
    Method: "POST",
    Url: COUPON_CHECK_APPLICABILITY,
    Data: DATA,
  });
};
